// extracted by mini-css-extract-plugin
export var chevron = "_fu-2";
export var dropdownItems = "_fu-0";
export var item = "_fu-1";